export default __webpack_public_path__ + "static/media/artrealmart.c0d978fb.png";